import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from '../reducers/';
import thunk from 'redux-thunk';

import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

// Object for default data from posts/post
const defaultState = {};


const enhancers = compose(
    window.location.hostname !== "portal.intouchnetworks.com" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
);

const store = createStore(
    rootReducer,
    defaultState,
    compose(
        applyMiddleware( thunk ),
        enhancers
    )
);

export const history = syncHistoryWithStore( browserHistory, store );
export default store;


// WEBPACK FOOTER //
// src/client/store/store.js